import { render } from "./TinyPumperAlertSwitch.vue?vue&type=template&id=094dcb86"
import script from "./TinyPumperAlertSwitch.vue?vue&type=script&lang=js"
export * from "./TinyPumperAlertSwitch.vue?vue&type=script&lang=js"

import "./TinyPumperAlertSwitch.vue?vue&type=style&index=0&id=094dcb86&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__